import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H1 } from 'components/common/Text/Text'
import Drawer from 'components/common/Drawer'

export const Wrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('margin', '75px auto 0', '15px auto 0')}
`
export const Title = styled(H1)`
  ${Mixin.font.GothamBold(34)}
  ${Mixin.responsive('margin', '0 8px 12px 8px', '0 8px 10px 8px')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(22)}
  `}
`

export const Description = styled.p`
  ${Mixin.responsive('font-size', '20px', '16px')}
  ${Mixin.responsive('margin', '0 8px 42px 8px', '0 8px 34px 8px')}
  padding-top: 10px;
`

export const BrandsDrawer = styled(Drawer)`
  [data-drawer-title] {
    ${Mixin.responsive('padding', '0 50px 0 20px', '0 50px 0 16px')}
  }

  [data-drawer-icon] {
    padding: 0;
    ${Mixin.responsive('top', '30px', '25px')}
  }

  ${Mixin.responsive('margin', '85px 0', '10px 0')}
  ${Mixin.responsive('padding', '30px 0', '18px 0')}
`
